import { render } from "./LicenseList.vue?vue&type=template&id=0a567283&ts=true"
import script from "./LicenseList.vue?vue&type=script&lang=ts"
export * from "./LicenseList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c14bfaf61e4aff3d2996531c89f90cfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__